"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsteroidMiningConsortiumRebalanced = void 0;
var Tags_1 = require("../../Tags");
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var Resources_1 = require("../../../Resources");
var CardName_1 = require("../../../CardName");
var DecreaseAnyProduction_1 = require("../../../deferredActions/DecreaseAnyProduction");
var CardRequirements_1 = require("../../CardRequirements");
var CardRenderer_1 = require("../../render/CardRenderer");
var AsteroidMiningConsortiumRebalanced = (function (_super) {
    __extends(AsteroidMiningConsortiumRebalanced, _super);
    function AsteroidMiningConsortiumRebalanced() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.ASTEROID_MINING_CONSORTIUM_REBALANCED,
            tags: [Tags_1.Tags.JOVIAN],
            cost: 13,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.generation(4); }),
            metadata: {
                description: 'Decrease any titanium production 1 step and increase your own 1 step.',
                cardNumber: '002',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.minus().titanium(-1).any.br;
                        pb.plus().titanium(1);
                    });
                }),
                victoryPoints: 1,
            },
        }) || this;
    }
    AsteroidMiningConsortiumRebalanced.prototype.canPlay = function (player) {
        if (!_super.prototype.canPlay.call(this, player)) {
            return false;
        }
        this.warning = undefined;
        if (_super.prototype.canPlay.call(this, player) && !player.game.someoneElseHasResourceProduction(Resources_1.Resources.TITANIUM, 1, player)) {
            this.warning = 'You will have to decrease your own titanium production because no other player has enough.';
        }
        return true;
    };
    AsteroidMiningConsortiumRebalanced.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.TITANIUM, 1);
        player.game.defer(new DecreaseAnyProduction_1.DecreaseAnyProduction(player, Resources_1.Resources.TITANIUM, 1));
        return undefined;
    };
    AsteroidMiningConsortiumRebalanced.prototype.getVictoryPoints = function () {
        return 1;
    };
    return AsteroidMiningConsortiumRebalanced;
}(Card_1.Card));
exports.AsteroidMiningConsortiumRebalanced = AsteroidMiningConsortiumRebalanced;
//# sourceMappingURL=AsteroidMiningConsortiumRebalanced.js.map